module.exports = __webpack_public_path__ + "img/F980.1bbe25e8.jpg";